import React, { useContext, useState } from "react";
import { featuresData } from "../../../global/utils/constants/featuresData";
import { LoginContext } from "../../../lib/loginContext";
import { useNavigate, useLocation } from "react-router-dom";
import UserMannual from "../../../../src/assets/svg/UserManual";
import IpFinder from "../../../../src/assets/svg/IpFinder";
import QuickStartGuide from "../../../../src/assets/svg/QuickStartGuide";
import NetworkGuide from "../../../../src/assets/svg/NetworkGuide";
import Flyer from "../../../../src/assets/svg/Flyer";
import ApplicationNote from "../../../../src/assets/svg/ApplicationNote";
import WireDiagram from "../../../../src/assets/svg/WireDiagram";
import Download from "../../../../src/assets/svg/Download";
import { UPLOADS_URL } from "../../../lib/apiConstants";
import IpInstaller from "../../../assets/svg/IpInstaller";

const ProductInfo = ({ product }) => {
  const features = product?.features?.split("|") || [];
  const filteredFeatures = featuresData.filter((feature) =>
    product?.features_icons?.some((d) => d.value === feature.id)
  );
  const { isLoggedIn } = useContext(LoginContext);
  const navigate = useNavigate();
  const location = useLocation();

  // State for error popup
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const isReaderProduct =
    product?.category?.toLowerCase() === "reader" || false;
  const flyer_link = product?.flyer_link || "#";
  const user_manual_link = product?.user_manual_link || "#";
  const ip_finder_link = product?.ip_finder_link || "#";
  const application_note_link = product?.application_note_link || "#";
  const wire_diagram_link = product?.wire_diagram_link || "#";
  const network_guide_link = product?.network_guide_link || "#";
  const quick_guide_link = product?.quick_guide_link || "#";
  const isCredentialProduct =
    product?.category?.toLowerCase() === "credential" || false;

  // Function to show error popup
  const showError = (message) => {
    setErrorMessage(message);
    setShowErrorPopup(true);
    setTimeout(() => {
      setShowErrorPopup(false);
    }, 4000); // Auto hide after 4 seconds
  };

  // Function to check if link is valid
  const isValidLink = (link) => {
    return link && link !== "#" && link.trim() !== "";
  };

  // Enhanced helper function for downloading files with better security
  const downloadFile = async (filename, fileUrl) => {
    try {
      // Create a temporary link element
      const link = document.createElement("a");

      // Set the download attributes
      link.href = fileUrl;
      link.download = filename;
      link.rel = "noopener noreferrer"; // Security enhancement
      link.style.display = "none";

      // Add to DOM, trigger click, then remove
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Optional: Show a notification to user
      console.log(`Downloading ${filename}`);
    } catch (error) {
      console.error(`Error downloading ${filename}:`, error);
    }
  };

  // Fixed function for IP Finder zip download - NO VALIDATION
  const downloadIPFinderZip = async () => {
    const zipFilename = "IP_Installer.zip";
    const zipUrl = `${UPLOADS_URL}IP_Installer.zip`;

    try {
      console.log("Attempting to download ZIP from:", zipUrl);
      await downloadFile(zipFilename, zipUrl);
    } catch (error) {
      console.error("Error downloading ZIP file:", error);

      // Fallback to original exe file if ZIP download fails
      console.warn("ZIP file download failed, trying EXE instead");
      try {
        const exeUrl = `${UPLOADS_URL}${ip_finder_link}`;
        await downloadFile("IP_Installer.exe", exeUrl);
      } catch (exeError) {
        console.error("EXE download also failed:", exeError);
        showError(
          "Download failed. Please try again later or contact support."
        );
      }
    }
  };

  // Function for IP Download zip download - NO VALIDATION
  const downloadIPDownloadZip = async () => {
    const zipFilename = "IP_Finder.zip";
    const zipUrl = `${UPLOADS_URL}IP_Finder.zip`;

    try {
      console.log("Attempting to download ZIP from:", zipUrl);
      await downloadFile(zipFilename, zipUrl);
    } catch (error) {
      console.error("Error downloading ZIP file:", error);
      showError("Download failed. Please try again later or contact support.");
    }
  };

  // Handle document click with validation
  const handleDocumentClick = (link, documentName) => {
    if (!isValidLink(link)) {
      showError(`${documentName} is not available for this product.`);
      return;
    }
    window.open(`${UPLOADS_URL}${link}`, "_blank", "noopener,noreferrer");
  };

  // Handle login navigation from ProductInfo

  return (
    <div className="">
      {product?.title && (
        <h1 className="text-[24px] max-[450px]:text-[22px] font-[Poppins] max-[450px]:max-w-full max-w-[650px] text-[#121212] font-semibold line-clamp-2 max-[450px]:leading-9 leading-[41.6px]">
          {product?.title}
        </h1>
      )}
      {product?.subtitle && (
        <p className="text-[#4A4C56] max-w-[584px] font-medium text-[16px] leading-[24px] mt-1">
          {product?.subtitle}
        </p>
      )}

      {/* Product Price */}
      {/* {isLoggedIn && product?.product_price && (
        <p className="text-[#016FFC] font-[Poppins] text-[20px] font-semibold leading-[150%] mt-1">
          Price : ${product?.product_price}
        </p>
      )} */}

      {/* Show download buttons only if logged in */}
      {isLoggedIn && (
        <div
          className="
   flex flex-wrap gap-x-[16px] gap-y-4
   mt-4

   max-[768px]:gap-x-3
   max-[425px]:grid
   max-[425px]:grid-cols-3 max-[425px]:grid-rows-3
   max-[425px]:gap-x-[44px] max-[425px]:gap-y-[16px]
   max-[425px]:px-[24px]
   max-[425px]:justify-center
"
        >
          {/* USER MANUAL */}
          {user_manual_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px]">
              <button
                onClick={() =>
                  handleDocumentClick(user_manual_link, "User Manual")
                }
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <UserMannual
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    User Manual
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212] whitespace-nowrap">
                User Manual
              </p>
            </div>
          )}

          {/* IP DOWNLOAD - New button, downloads IP_Finder.zip */}
          {!isReaderProduct && ip_finder_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[6px]">
              <button
                onClick={downloadIPDownloadZip}
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              cursor-pointer
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <IpInstaller
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    IP Finder - V1
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212] whitespace-nowrap">
                IP Finder - V1
              </p>
              {/* <div className="hidden max-[450px]:block text-[10px] text-gray-500 mt-1">
                ZIP File
              </div> */}
            </div>
          )}
          {/* IP FINDER - Updated with ZIP download - ALWAYS SHOW, NO VALIDATION */}
          {!isReaderProduct && ip_finder_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[6px]">
              <button
                onClick={downloadIPFinderZip}
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              cursor-pointer
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <IpFinder
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    IP Installer - V2
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212] whitespace-nowrap">
                IP Installer - V2
              </p>
              {/* <div className="hidden max-[450px]:block text-[10px] text-gray-500 mt-1">
                ZIP File
              </div> */}
            </div>
          )}
          {/* WIRE DIAGRAM */}
          {wire_diagram_link && !isCredentialProduct && !isReaderProduct && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[6px]">
              <button
                onClick={() =>
                  handleDocumentClick(wire_diagram_link, "Wire Diagram")
                }
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <WireDiagram
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    Wire Diagram
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212] whitespace-nowrap">
                Wire Diagram
              </p>
            </div>
          )}

          {/* APPLICATION NOTE */}
          {!isReaderProduct && application_note_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[7px]">
              <button
                onClick={() =>
                  handleDocumentClick(application_note_link, "Application Note")
                }
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <ApplicationNote
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    Application Note
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212]">
                Application Note
              </p>
            </div>
          )}

          {/* FLYER */}
          {flyer_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[6px]">
              <button
                onClick={() => handleDocumentClick(flyer_link, "Spec Sheet")}
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <Flyer
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    Spec Sheet
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212]">
                Spec Sheet
              </p>
            </div>
          )}

          {/* NETWORK GUIDE */}
          {!isReaderProduct && network_guide_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[6px]">
              <button
                onClick={() =>
                  handleDocumentClick(network_guide_link, "Network Guide")
                }
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <NetworkGuide
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    Network Guide
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212]">
                Network Guide
              </p>
            </div>
          )}

          {/* QUICK START GUIDE */}
          {!isReaderProduct && quick_guide_link && (
            <div className="max-[425px]:flex max-[425px]:flex-col max-[425px]:items-center max-[450px]:w-[56px] max-[450px]:px-[6px]">
              <button
                onClick={() =>
                  handleDocumentClick(quick_guide_link, "QuickStart Guide")
                }
                className="
              w-[180px] h-[44px]
              flex items-center justify-between
              transition-all duration-200
              px-4 py-2
              border border-[#6781CF] hover:bg-[#ECF1FF] bg-[#F8F9FD]
              hover:shadow-md
              rounded-md
              group
              
              max-[450px]:w-[56px] max-[450px]:h-[56px]
              max-[450px]:p-0 max-[450px]:rounded-full
              max-[450px]:justify-center max-[450px]:items-center
              max-[450px]:opacity-80
            "
              >
                <div className="flex items-center gap-2 max-[450px]:gap-0">
                  <QuickStartGuide
                    width={20}
                    height={20}
                    className="max-[450px]:w-[22px] max-[450px]:h-[22px]"
                  />
                  <p className="text-[#3A3A41] font-[Poppins] text-[12px] font-normal text-left max-[450px]:hidden">
                    QuickStart Guide
                  </p>
                </div>
                <Download
                  width={16}
                  height={16}
                  className="text-[#6781CF] group-hover:text-[#4B68C6] max-[450px]:hidden"
                />
              </button>
              <p className="hidden max-[450px]:block text-[10px] text-center mt-2 text-[#121212]">
                Quick Guide
              </p>
            </div>
          )}
        </div>
      )}

      {/* Error Popup - Bottom of Page */}
      {showErrorPopup && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 z-50 animate-slide-up">
          <div className="bg-red-50 border-l-4 border-red-500 rounded-lg shadow-lg px-6 py-4 max-w-md">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg
                  className="h-5 w-5 text-red-500"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                    clipRule="evenodd"
                  />
                </svg>
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium text-red-800">
                  {errorMessage}
                </p>
              </div>
              <div className="ml-4 flex-shrink-0">
                <button
                  onClick={() => setShowErrorPopup(false)}
                  className="inline-flex text-red-500 hover:text-red-700 focus:outline-none"
                >
                  <svg
                    className="h-5 w-5"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* features as icon */}
      <div className="flex items-center max-md:flex-wrap gap-3 mt-5">
        {filteredFeatures?.map((feature, index) => {
          return (
            <div
              key={index}
              className="flex items-center justify-center w-[78px] h-[56px] border-[1px] border-[#8A8B91] px-1 py-[1px] bg-[#FFF] rounded-lg"
            >
              <img
                src={feature?.image}
                alt="Intertek"
                className={`h-full w-full object-fill`}
              />
            </div>
          );
        })}
      </div>

      {/* key features */}
      <div className="mt-5">
        <h2 className="text-[#121212] text-[18px] font-semibold mb-2">
          Key Features
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            {features
              .slice(0, Math.ceil(features.length / 2))
              .map((item, index) => (
                <div
                  key={index}
                  className="flex items-center mb-[10px] last:mb-0 gap-2"
                >
                  <div className="w-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#4A4C56" />
                    </svg>
                  </div>
                  <p className="text-[#000] text-[13px] leading-6 font-medium">
                    {item}
                  </p>
                </div>
              ))}
          </div>
          <div>
            {features
              .slice(Math.ceil(features.length / 2))
              .map((item, index) => (
                <div
                  key={index}
                  className="flex items-center mb-[10px] last:mb-0 gap-2"
                >
                  <div className="w-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="4"
                      height="4"
                      viewBox="0 0 4 4"
                      fill="none"
                    >
                      <circle cx="2" cy="2" r="2" fill="#4A4C56" />
                    </svg>
                  </div>
                  <p className="text-[#000] text-[13px] leading-6 font-medium">
                    {item}
                  </p>
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Add CSS for animation */}
      <style jsx>{`
        @keyframes slideUp {
          from {
            transform: translate(-50%, 100%);
            opacity: 0;
          }
          to {
            transform: translate(-50%, 0);
            opacity: 1;
          }
        }
        .animate-slide-up {
          animation: slideUp 0.3s ease-out;
        }
      `}</style>

      {/* Login message if not logged in */}
      {/* {!isLoggedIn && (
        <div className="mt-6 text-center">
          <p className="text-[16px] text-gray-700 ">
            *Please{" "}
            <span
              onClick={handleLoginClick}
              className="text-blue-600 cursor-pointer hover:underline not-italic font-semibold"
            >
              Login
            </span>{" "}
            to see product price and manuals*
          </p>
        </div>
      )} */}
    </div>
  );
};

export default ProductInfo;
